<script setup>
import { computed } from 'vue';

const props = defineProps({
  text: { type: String, required: true },
});

const nombreSinHorario = computed(() => {
  const match = props.text.match(/^(.+?)\s*\[/);
  return match ? match[1] : props.text;
});

const horarioText = computed(() => {
  const match = props.text.match(/\[(.+?)\]/);
  return match ? match[1] : '';
});
</script>

<template>
  <span class="opcion-horarios">
    <span>{{ nombreSinHorario }}</span>
    <span v-if="horarioText" class="label label-success">{{ horarioText }}</span>
  </span>
</template>

<style lang="scss" scoped>
.opcion-horarios {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
}
</style>
